"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Remove = _interopRequireDefault(require("elevate-ui-icons/Remove"));

var _Add = _interopRequireDefault(require("elevate-ui-icons/Add"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Scaffold = _interopRequireDefault(require("../Scaffold"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Number input that can be adjusted incrementally
 */
var NumberIncrement =
/*#__PURE__*/
function (_Component) {
  _inherits(NumberIncrement, _Component);

  function NumberIncrement() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NumberIncrement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NumberIncrement)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleValueChange", function (direction) {
      var places = _this.props.places >= 0 ? _this.props.places : 2;
      var newValue = Number(_this.input.value);

      if (direction === "increment") {
        if (_this.props.step) {
          newValue += _this.props.step;
        } else {
          newValue++;
        }
      } else {
        if (_this.props.step) {
          newValue -= _this.props.step;
        } else {
          newValue--;
        }
      }

      if (_this.props.onChange) {
        _this.props.onChange(newValue.toFixed(places));
      }

      return _this.props.form.setFieldValue(_this.props.field.name, newValue.toFixed(places));
    });

    return _this;
  }

  _createClass(NumberIncrement, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          field = _this$props.field,
          _this$props$form = _this$props.form,
          touched = _this$props$form.touched,
          errors = _this$props$form.errors,
          setFieldValue = _this$props$form.setFieldValue,
          id = _this$props.id,
          label = _this$props.label,
          theme = _this$props.theme,
          _this$props$withScaff = _this$props.withScaffold,
          withScaffold = _this$props$withScaff === void 0 ? true : _this$props$withScaff,
          rest = _objectWithoutProperties(_this$props, ["classes", "className", "field", "form", "id", "label", "theme", "withScaffold"]);

      var NumberInput = _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.root, className)
      }, _react["default"].createElement("button", {
        className: (0, _classnames["default"])(classes.button, classes.buttonLeft),
        type: "button",
        onClick: function onClick() {
          return _this2.handleValueChange("decrement");
        }
      }, _react["default"].createElement(_Remove["default"], {
        size: 16
      })), _react["default"].createElement("input", _extends({
        className: classes.input,
        type: "number",
        id: id,
        ref: function ref(node) {
          return _this2.input = node;
        }
      }, field, rest, {
        onChange: function onChange() {
          setFieldValue(field.name, _this2.input.value);

          if (_this2.props.onChange) {
            _this2.props.onChange(_this2.input.value);
          }
        }
      })), _react["default"].createElement("button", {
        className: (0, _classnames["default"])(classes.button, classes.buttonRight),
        type: "button",
        onClick: function onClick() {
          return _this2.handleValueChange("increment");
        }
      }, _react["default"].createElement(_Add["default"], {
        size: 16
      })));

      if (withScaffold) {
        return _react["default"].createElement(_Scaffold["default"], {
          id: id,
          label: label,
          error: (0, _get["default"])(touched, field.name) && (0, _get["default"])(errors, field.name)
        }, NumberInput);
      } else {
        return NumberInput;
      }
    }
  }]);

  return NumberIncrement;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-start",
      alignItems: "stretch",
      position: "relative"
    },
    input: {
      display: "inline-block",
      width: "68px",
      height: "auto",
      color: theme.typography.bodyColor,
      fontFamily: "inherit",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px",
      textAlign: "center",
      backgroundColor: "#fff",
      border: "1px solid ".concat(theme.colors.gray300),
      borderLeft: "none",
      borderRight: "none",
      borderRadius: 0,
      padding: "8px 5px 8px 17px",
      boxShadow: "none",
      // Reset default inputs for mozilla
      "-webkit-appearance": "none",
      // Reset default browser styles
      "-moz-appearance": "none",
      // Reset default browser styles
      "&:disabled": {
        cursor: "not-allowed"
      }
    },
    button: {
      display: "inline-flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "auto",
      width: 40,
      backgroundColor: theme.colors.primary["500"],
      color: "#fff"
    },
    buttonLeft: {
      borderTopLeftRadius: theme.globalBorderRadius,
      borderBottomLeftRadius: theme.globalBorderRadius
    },
    buttonRight: {
      borderTopRightRadius: theme.globalBorderRadius,
      borderBottomRightRadius: theme.globalBorderRadius
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiNumberIncrement"
})(NumberIncrement);

exports["default"] = _default;